import { useEffect, lazy, Suspense } from 'react';
import { Providers } from '@repo/app-providers';
import { useIsMounted, useSetEnvConfigFromIframe } from '@repo/hooks';
import { updateEnv } from '@repo/env';

import { LoanProcessModal } from '@/components/loan-process/loan-process-modal/loan-process-modal';
import { DisplayModal } from '@/components/modal/display-modal';

import { MainHub } from './main-hub';

const MainPlayground = __IS_TESTMODE_STANDALONE__
  ? lazy(() =>
      import('./main.playground').then((module) => ({
        default: module.MainPlayground,
      })),
    )
  : null;

export function MainApp() {
  // This hook is use only for tests. Read the description, which is included in the hook file.
  const { status } = useSetEnvConfigFromIframe();
  const isMounted = useIsMounted();

  useEffect(() => {
    if (window.config && import.meta.env.PROD) {
      updateEnv(window.config);
    }
  }, []);

  if (status !== 'FINISH' || !isMounted()) return null;

  return (
    <Providers>
      {__IS_TESTMODE_STANDALONE__ && MainPlayground ? (
        <Suspense>
          <MainPlayground />
        </Suspense>
      ) : null}
      <MainHub />
      <LoanProcessModal />
      <DisplayModal />
    </Providers>
  );
}
